// Drop-in entry for sub-pages: <script type="module" src="/src/landing/page-fx-auto.ts">
import { initPageFx } from "./page-fx.js";
initPageFx();
